import React from 'react';
import FiltersCard from '../../../components/FiltersCard';
import { Row, Col, Form, InputGroup } from '@/components/ui';

interface ActivityFiltersProps {
  filters: {
    classification: string;
    profile: string;
  };
  search: string;
  onFilterChange: (name: string, value: string) => void;
  onSearchChange: (value: string) => void;
  onClearFilters: () => void;
  profiles: string[];
}

const ActivityFilters: React.FC<ActivityFiltersProps> = ({
  filters,
  search,
  onFilterChange,
  onSearchChange,
  onClearFilters,
  profiles,
}) => {
  const hasActiveFilters =
    filters.classification !== '' || filters.profile !== '' || search !== '';

  return (
    <FiltersCard
      title="Activity Filters"
      subtitle="Search and filter activities by classification and profile"
      collapsible={true}
      defaultCollapsed={false}
      showClearButton={true}
      onClear={onClearFilters}
      hasActiveFilters={hasActiveFilters}
    >
      <Row className="tw-items-end">
        <Col xs={12}>
          <Form.Label>Search</Form.Label>
          <InputGroup>
            <InputGroup.Text>
              <i className="bi bi-search"></i>
            </InputGroup.Text>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Search number, name, or location code"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col md={6}>
          <Form.Label>Classification</Form.Label>
          <Form.Select
            size="sm"
            name="classification"
            value={filters.classification}
            onChange={(e) => onFilterChange(e.target.name, e.target.value)}
          >
            <option value="">All Classifications</option>
            <option value="routine">Routine</option>
            <option value="quantified">Quantified</option>
            <option value="overhead">Overhead</option>
          </Form.Select>
        </Col>
        <Col md={6}>
          <Form.Label>Profile</Form.Label>
          <Form.Select
            size="sm"
            name="profile"
            value={filters.profile}
            onChange={(e) => onFilterChange(e.target.name, e.target.value)}
          >
            <option value="">All Profiles</option>
            {profiles.map(profile => (
              <option key={profile} value={profile}>
                {profile}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
    </FiltersCard>
  );
};

export default ActivityFilters;
